// 🤗 Câliner — dans le noir : l'adversaire s'est perdu au fond de l'impasse la plus lointaine. Le
// joueur ne voit qu'autour de lui ; l'adversaire appelle à l'aide (visible un instant) tous les
// PING_EVERY tics.
import { baseState, countTick, distanceMap, finish, sameCell, timeGain } from './common.js';
import { countWalls } from '../maze.js';
import { POINTS_PER_CELL } from '../../config/constants.js';

export const FOG_RADIUS = 2.5;
export const PING_EVERY = 5;

/**
 * L'impasse la plus éloignée de `from` en pas, parmi celles loin à vol d'oiseau aussi (au moins la
 * moitié du labyrinthe : une impasse à deux cases derrière un mur serait visible dès le départ) ;
 * à défaut, la case la plus éloignée. Renvoie aussi sa distance en pas.
 */
export function farthestDeadEnd(grid, from) {
  const dist = distanceMap(grid, from);
  const minSpan = grid.length / 2;
  let best = null;
  let bestDeadEnd = null;
  dist.forEach((row, y) => row.forEach((d, x) => {
    if (d <= 0) return;
    if (!best || d > best.d) best = { x, y, d };
    const far = Math.hypot(x - from.x, y - from.y) >= minSpan;
    if (far && countWalls(grid[y][x]) === 3 && (!bestDeadEnd || d > bestDeadEnd.d)) bestDeadEnd = { x, y, d };
  }));
  return bestDeadEnd ?? best ?? { x: from.x, y: from.y, d: 0 };
}

export const hug = {
  id: 'hug',
  create(ctx) {
    const { x, y, d } = farthestDeadEnd(ctx.grid, ctx.player);
    const distance = Math.max(1, d);
    return baseState(ctx, {
      rival: { x, y },
      fullGain: distance * POINTS_PER_CELL,
      budget: Math.max(8, Math.ceil(distance * 2.5)),
      idleTicks: 3,
      fog: FOG_RADIUS,
      ping: true,
    });
  },
  tick(state) {
    const next = countTick(state);
    return next.result ? next : { ...next, ping: next.ticks % PING_EVERY === 0 };
  },
  enter: (state, { player }) => (sameCell(state.rival, player) ? finish(state, 'win') : state),
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [{ key: 'scenario.hug.hint.rival', cell: state.rival }],
};
